import { type Model } from 'algu-domain'

import { type DomainEntityId, type ProductPreset } from '@salsita-ai/platform-project-sdk/domain'

export const preset: ProductPreset<Model.AnyDomainEntity, Model.RootEntity> = {
  name: 'Algu dining table',
  description: 'Initial table configuration',
  rootEntityType: 'Table',
  initialDomainEntities: [
    {
      id: 'Table-1' as DomainEntityId<'Table'>,
      type: 'Table',
      height: 760,
      legsId: 'LegsRobuDoubleEik-1' as DomainEntityId<'LegsRobuDoubleEik'>,
      topId: 'TopOval-1' as DomainEntityId<'TopOval'>,
    },
    {
      id: 'TopOval-1' as DomainEntityId<'TopOval'>,
      type: 'TopOval',
      color: 'UltraMatteLak',
      length: 2400,
      width: 1000,
      edgeFinish: 'Standard',
      fenixVariant: 'None',
      material: 'SolidOak',
      thickness: 40,
      topFinish: 'NewOak',
    },
    {
      id: 'LegsRobuDoubleEik-1' as DomainEntityId<'LegsRobuDoubleEik'>,
      type: 'LegsRobuDoubleEik',
      color: 'UltraMatteLak',
      legOffset: 300,
    },
  ],
}
